(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["em-guide-hub"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalise = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const brands = [
      ['alfa-romeo', 'Alfa Romeo', /alfa\s+romeo/], ['audi', 'Audi', /\baudi\b/], ['bmw', 'BMW', /\bbmw\b/],
      ['fiat', 'Fiat', /\bfiat\b/], ['ford', 'Ford', /\bford\b/], ['honda', 'Honda', /\bhonda\b/],
      ['mazda', 'Mazda', /\bmazda\b|\bmiata\b/], ['mercedes', 'Mercedes', /\bmercedes\b/],
      ['nissan', 'Nissan', /\bnissan\b/], ['opel', 'Opel', /\bopel\b/], ['peugeot', 'Peugeot', /\bpeugeot\b/],
      ['subaru', 'Subaru', /\bsubaru\b|\bbrz\b/], ['tesla', 'Tesla', /\btesla\b/], ['toyota', 'Toyota', /\btoyota\b/],
      ['volkswagen', 'Volkswagen', /\bvolkswagen\b|\bvw\b|\bgolf\b|\bscirocco\b/]
    ];
    const init = (scope) => {
      scope.querySelectorAll('[data-eg-hub]').forEach((hub) => {
        if (hub.dataset.egReady) return;
        const cards = Array.from(hub.querySelectorAll('[data-eg-card]'));
        if (!cards.length) return;
        const grid = hub.querySelector('[data-eg-grid]');
        const search = hub.querySelector('[data-eg-search]');
        const brand = hub.querySelector('[data-eg-brand]');
        const sort = hub.querySelector('[data-eg-sort]');
        const topicButtons = Array.from(hub.querySelectorAll('[data-eg-topic]'));
        const results = hub.querySelector('[data-eg-results]');
        const moreWrap = hub.querySelector('[data-eg-more-wrap]');
        const more = hub.querySelector('[data-eg-more]');
        const empty = hub.querySelector('[data-eg-empty]');
        const showing = hub.querySelector('[data-eg-showing]');
        const labels = JSON.parse(hub.querySelector('[data-eg-labels]').textContent);
        const records = cards.map((card, index) => ({
          card, index, text: normalise(card.dataset.search), title: card.dataset.title,
          topic: card.dataset.topic, date: Number(card.dataset.date), brands: []
        }));
        records.forEach((record) => { record.brands = brands.filter((entry) => entry[2].test(record.text)).map((entry) => entry[0]); });
        brands.forEach(([value, label]) => {
          if (!records.some((record) => record.brands.includes(value))) return;
          const option = document.createElement('option'); option.value = value; option.textContent = label; brand.append(option);
        });
        if (brand.options.length === 1) { brand.closest('.eg-select').hidden = true; brand.closest('.eg-search-row').classList.add('eg-search-row--no-brand'); }
        topicButtons.forEach((button) => {
          const count = button.dataset.egTopic === 'all' ? records.length : records.filter((record) => record.topic === button.dataset.egTopic).length;
          button.querySelector('[data-eg-count]').textContent = count;
          button.hidden = count === 0;
        });
        let topic = 'all';
        let limit = 12;
        let currentMatches = [];
        let timer;
        const syncUrl = () => {
          const url = new URL(window.location.href);
          const values = { cerca: search.value.trim(), argomento: topic === 'all' ? '' : topic, marca: brand.value, ordine: sort.value === 'newest' ? '' : sort.value };
          Object.entries(values).forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
          window.history.replaceState(null, '', url.pathname + url.search + url.hash);
        };
        const apply = (updateUrl = true) => {
          const tokens = normalise(search.value).split(' ').filter(Boolean);
          currentMatches = records.filter((record) => (topic === 'all' || record.topic === topic) && (!brand.value || record.brands.includes(brand.value)) && tokens.every((token) => record.text.includes(token)));
          currentMatches.sort((a, b) => sort.value === 'az' ? a.title.localeCompare(b.title, document.documentElement.lang || 'it') : sort.value === 'oldest' ? a.date - b.date || a.index - b.index : b.date - a.date || a.index - b.index);
          records.forEach((record) => { record.card.hidden = true; });
          const fragment = document.createDocumentFragment();
          currentMatches.forEach((record, index) => { record.card.hidden = index >= limit; fragment.append(record.card); });
          grid.append(fragment);
          results.textContent = currentMatches.length === 1 ? labels.resultOne : labels.results.replace('__COUNT__', currentMatches.length);
          showing.textContent = labels.showing.replace('__SHOWN__', Math.min(limit, currentMatches.length)).replace('__TOTAL__', currentMatches.length);
          empty.hidden = currentMatches.length !== 0;
          moreWrap.hidden = currentMatches.length <= limit;
          topicButtons.forEach((button) => {
            const active = button.dataset.egTopic === topic;
            button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active));
          });
          if (updateUrl) syncUrl();
        };
        const readUrl = () => {
          const params = new URL(window.location.href).searchParams;
          search.value = params.get('cerca') || '';
          topic = topicButtons.some((button) => !button.hidden && button.dataset.egTopic === params.get('argomento')) ? params.get('argomento') : 'all';
          brand.value = Array.from(brand.options).some((option) => option.value === params.get('marca')) ? params.get('marca') : '';
          sort.value = ['newest', 'oldest', 'az'].includes(params.get('ordine')) ? params.get('ordine') : 'newest';
          limit = 12; apply(false);
        };
        search.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => { limit = 12; apply(); }, 120); });
        [brand, sort].forEach((control) => control.addEventListener('change', () => { limit = 12; apply(); }));
        topicButtons.forEach((button) => button.addEventListener('click', () => { topic = button.dataset.egTopic; limit = 12; apply(); }));
        more.addEventListener('click', () => { const previousLimit = limit; limit += 12; apply(false); currentMatches[previousLimit]?.card.querySelector('a').focus({ preventScroll: true }); });
        hub.querySelector('[data-eg-reset]').addEventListener('click', () => { search.value = ''; brand.value = ''; sort.value = 'newest'; topic = 'all'; limit = 12; apply(); search.focus({ preventScroll: true }); });
        window.addEventListener('popstate', readUrl);
        hub.dataset.egReady = 'true';
        hub.querySelector('[data-eg-controls]').hidden = false;
        readUrl();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
